import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="shared-password"
// Copies the visible password/OTP input value into a hidden field inside the submitting form.
export default class extends Controller {
  static targets = ["source"]

  submit(event) {
    if (!this.sourceTarget.value.trim()) {
      event.preventDefault()
      this.sourceTarget.focus()
      this.sourceTarget.classList.add("is-invalid")
      return
    }

    this.sourceTarget.classList.remove("is-invalid")
    const form = event.target.closest("form")
    const hiddenInput = form?.querySelector("[data-shared-password-field]")

    if (hiddenInput) {
      hiddenInput.value = this.sourceTarget.value
    }
  }
}
